import { NgModule } from '@angular/core';
import { AuswertungenFormdialogNeuComponent } from './components/auswertungen-formdialog-neu/auswertungen-formdialog-neu.component';
import { AuswertungenPageComponent } from './components/auswertungen-page/auswertungen-page.component';
import { AuswertungenListComponent } from './components/auswertungen-list/auswertungen-list.component';
import { AuswertungenTableComponent } from './components/auswertungen-table/auswertungen-table.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTreeModule } from '@angular/material/tree';
import { AuswertungenStufenComponent } from './components/auswertungen-stufen/auswertungen-stufen.component';
import { MatSortModule } from '@angular/material/sort';
import {ColorPickerModule} from 'ngx-color-picker';
import { SharedModule } from '../../shared.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {MatTabsModule} from '@angular/material/tabs/';
import {AuswertungenService} from './auswertungen.service';
import {auswertungenReducer} from './store/reducer/auswertungen.reducer';
import {AuswertungenEffects} from './store/effects/auswertungen.effects';
import {MatRadioModule} from "@angular/material/radio";
import {AuswertungFerienFormComponent} from '@src/app/pages/auswertungen/components/auswertungenferien-form/auswertungenferien-form.component';

@NgModule({
  imports: [
    StoreModule.forFeature('auswertungen', auswertungenReducer),
    EffectsModule.forFeature([AuswertungenEffects]),
    MatToolbarModule,
    TranslateModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatCheckboxModule,
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    MatDatepickerModule,
    FlexLayoutModule,
    MatTableModule,
    MatMenuModule,
    MatSelectModule,
    MatTreeModule,
    MatSortModule,
    ColorPickerModule,
    SharedModule,
    MatTooltipModule,
    TooltipModule,
    MatTabsModule,
    MatRadioModule
  ],
  providers: [ AuswertungenService],
  declarations: [
    AuswertungenFormdialogNeuComponent,
    AuswertungenPageComponent,
    AuswertungenListComponent,
    AuswertungenTableComponent,
    AuswertungenStufenComponent,
    AuswertungFerienFormComponent
  ],
})
export class AuswertungenPageComponentModule { }
